"use client";

import { ContactPremiumHero } from "@/components/contact/premium/ContactPremiumHero";
import { ContactPremiumSection } from "@/components/contact/premium/ContactPremiumSection";

export function ContactPageView() {
  return (
    <div className="contact-premium relative overflow-x-hidden">
      <ContactPremiumHero />
      <ContactPremiumSection />
    </div>
  );
}
